import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import Signup from "./Signup";
import ForgotPassword from "./ForgotPassword";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "react-bootstrap";
import { InputOTP } from "antd-input-otp";
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { Modal, ListGroup } from "react-bootstrap";
import "./Style.css";
import EyeIconSvg from "../assets/svg/eyeIconSvg";
import EyeIconHideSvg from "../assets/svg/eyeIconHideSvg";

function Login({
  setSignup = () => { },
  setForgot = () => { },
  modal = () => { },
  forgot = false,
  signup = false,
  show = false,
  setShow = () => { },
  windowEvent = false,
  useModal = true, 
  customButtonStyle = false,
  priceAlertModal= false
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const intervalRef = useRef(null);
  const usernameInputRef = useRef(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [statusAdmin, setStatusAdmin] = useState(false);
  const [error, setError] = useState(false);
  const [stap, setStap] = useState(true);
  const [passwordStatus, setPasswordStatus] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [otp, setOTP] = useState("")
  const [timer, setTimer] = useState(null);
  const [userid, setUserid] = useState();

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "username") {
      const cursorPos = event.target.selectionStart;
      setUsername(value.toLowerCase());
      setTimeout(() => usernameInputRef.current?.setSelectionRange(cursorPos, cursorPos), 0);
    } else if (name === "password") {
      setPassword(value);
    }
  };

  const handleSignup = () => {
    setStap(false);
    setSignup(true);
    setForgot(false);
  };

  const handleLogin = () => {
    setStap(true);
    setSignup(false);
    setForgot(false);
  };

  const handleForgotPassword = () => {
    setStap(false);
    setSignup(false);
    setForgot(true);
  };


  const startTimer = () => {
    // Clear any existing interval before starting a new one
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    let timeLeft = 53; // reset to 53 seconds
    setTimer(timeLeft);

    intervalRef.current = setInterval(() => {
      timeLeft -= 1;
      setTimer(timeLeft);

      if (timeLeft <= 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, 1000);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (window.Tawk_API) {
      console.log("Shutting down Tawk.to...");
      // window.Tawk_API.shutdown();
    }

    //handling affiliate attribution
    const affiliate_attribution_obj = localStorage.getItem("affiliate_attribution");
    let affiliate_attribution;

    if (affiliate_attribution_obj) {
      const affiliate_attribution_parsed = JSON.parse(affiliate_attribution_obj);
      affiliate_attribution = {
        affiliate_id: affiliate_attribution_parsed.affiliate_id ?? null,
        affiliate_seen_at: affiliate_attribution_parsed.affiliate_seen_at ?? null,
      }
    }
    else {
      affiliate_attribution = {
        affiliate_id: null,
        affiliate_seen_at: null
      }
    }


    const cookiesToDelete = [
      "token",
      "csrf_token",
      "_fbp",
      "__stripe_sid",
      "__stripe_mid",
    ];

    cookiesToDelete.forEach((cookieName) => {
      Cookies.remove(cookieName, { path: "/" }); // Removes from root path
      Cookies.remove(cookieName, { path: "", domain: window.location.hostname }); // Removes from specific domain
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
    });

    // Attempt to clear all cookies by iterating through document.cookie
    document.cookie.split(";").forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
    });


    // Get the secret key from environment variables
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    const usertoken = localStorage.getItem("tokenuser");
    const newData = JSON.parse(usertoken);

    const admintoken = localStorage.getItem("admin");
    const adminData = JSON.parse(admintoken);

    setButtonLoader(true);

    // Check if a user is already logged in
    if (newData) {
      toast.error("Another Account Already Logged In");
      setTimeout(() => {
        navigate("/");
        // navigate("/profile/" + newData.id);
      }, 2000);

      setButtonLoader(false);
      return;
    }

    // Check if an admin is already logged in

    if (adminData ) {
      toast.error("Admin Account Already Logged In");
      setTimeout(() => {
        navigate("/orderView");
      }, 2000);
      setButtonLoader(false);
      return;
    }

    // Check if both username and password are provided
    if (username && password) {
      try {
        // Encrypt the email and password before sending
        const emailLowercase = username.toLowerCase().trim();
        const encryptedEmail = CryptoJS.AES.encrypt(emailLowercase, secretKey).toString();
        const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey).toString();

        const resp = await ExportApi.UserLogin(encryptedEmail, encryptedPassword, affiliate_attribution);


        if (resp?.data?.message === "Account is temporarily locked. Try again later.") {
          toast.error("Your account is temporarily locked due to multiple failed login attempts. Please try again after 15 minutes.");
          setButtonLoader(false);
          return
        }
        // Check if the login was successful
        if (resp?.data?.message === "Login successful") {
          setError(true);
          setStap(false);

          // Store the user data in localStorage
          localStorage.setItem("favourite", JSON.stringify(resp.data.data.favourite));

          // Handle user login
          if (resp.data.data.role === "user") {
            setButtonLoader(false);
            toast.success(resp.data.data.Message);
            const loginTime = new Date().getTime();
            localStorage.setItem("loginTime", loginTime);
            localStorage.removeItem("token");
            localStorage.setItem("tokenuser", JSON.stringify(resp.data.data));
            let data = resp.data.data.shipping_address.street;
            localStorage.setItem("useraddress", JSON.stringify(data));

            // Navigate to the profile page
            if (location.pathname === "/") {
              navigate("/");
              // navigate("/profile/" + resp.data.data.id);
              // window.location.reload();
              modal();
            } else {
              navigate(location.href);
              modal();
              if (windowEvent) {
                window.dispatchEvent(new Event("handlingUserAction"));
              }
              // window.location.reload();
            }
          } else {
            // Handle admin login
            setButtonLoader(false);
            localStorage.removeItem("token");
            localStorage.setItem("admin", JSON.stringify(resp.data.data));
            const loginTime = new Date().getTime();
            localStorage.setItem("loginTime", loginTime);

            setStatusAdmin(true);
            if(!priceAlertModal){
              navigate("/productlist");
            }
            // window.location.reload();
          }
          window.dispatchEvent(new Event("authChange"));
        } else if (resp?.data?.message === "2FA required. OTP sent successfully.") {
          // Handle 2FA
          startTimer();
          setStap(false);
          setShowQRModal(true);
          setUserid(resp?.data?.userId);
          toast.success("OTP sent successfully");


        } else {
          // Handle login failure
          toast.error("Email and Password don't match");
          setButtonLoader(false);
        }
      } catch (err) {
        console.error(err, ">>>login error");
        toast.error("An error occurred during login.");
        setButtonLoader(false);
      }
    }
  };

  const handleOTPChange = (value) => {
    // Join array values into a single string
    setOTP(value.join(""));
  };

  const handleResend = () => {
    ExportApi.resendloginotp(userid)
      .then((resp) => {
        if (resp.data.status === true) {
          toast.success("OTP sent successfully");
          startTimer();
        }
        else {
          toast.error("Something went wrong. Please try again later.");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong. Please try again later.");
      })
  }

  const handleOTPSubmit = () => {
    setButtonLoader(true);

    ExportApi.verifyloginotp(otp, userid)
      .then((resp) => {
        if (resp.data.status === true) {
          const userData = resp.data.data;

          // Store favourites
          localStorage.setItem("favourite", JSON.stringify(userData.favourite));

          // Handle user login
          if (userData.role === "user") {
            toast.success(userData.Message);

            const loginTime = new Date().getTime();
            localStorage.setItem("loginTime", loginTime);

            localStorage.removeItem("token");
            localStorage.setItem("tokenuser", JSON.stringify(userData));

            // Save address
            let data = userData.shipping_address.street;
            localStorage.setItem("useraddress", JSON.stringify(data));

            // Navigate
            if (location.pathname === "/") {
              navigate("/");
              // navigate("/profile/" + userData.id);
              modal();
            } else {
              navigate(location.href);
              modal();
            }
          } else {
            // Handle admin login
            localStorage.removeItem("token");
            localStorage.setItem("admin", JSON.stringify(userData));

            const loginTime = new Date().getTime();
            localStorage.setItem("loginTime", loginTime);

            setStatusAdmin(true);
            navigate("/productlist");
          }
          window.dispatchEvent(new Event("authChange"));
        } else {
          toast.error("OTP verification failed. Please try again");
        }
      })
      .catch((error) => {
        console.error("Error verifying OTP: Please try again", error);
        toast.error("Something went wrong. Please try again later.");
      })
      .finally(() => {
        setButtonLoader(false);
      });
  };


  return (
    <div>
      <ToastContainer />
      {
        useModal ? (
          <Modal show={show} onHide={() => setShow(false)} backdrop={true} keyboard={false}>
            <Modal.Header closeButton>
              {
                signup ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <h4 style={{ fontWeight: 650 }} className="text-center cursor-pointer m-0">Create your free GPUwiz account
                    </h4>
                  </div>
                ) : forgot ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <h4 style={{ fontWeight: 650 }} className="text-center cursor-pointer m-0">Forgot Password
                    </h4>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <h4 style={{ fontWeight: 650 }} className="text-center cursor-pointer m-0">Log in to GPUwiz
                    </h4>
                  </div>
                )
              }
            </Modal.Header>
            <Modal.Body className="scrollable-modal-body">
              {
                signup ? (
                  <Signup
                    windowEvent={windowEvent}
                    setSignup={setSignup}
                    setForgot={setForgot}
                    modal={modal}
                    customButtonStyle={customButtonStyle} />
                ) : forgot ? (
                  <ForgotPassword setSignup={setSignup}
                    setForgot={setForgot}
                    modal={modal}
                    customButtonStyle={customButtonStyle} />
                ) : (
                  <>
                    <div>
                      <p
                        className="max-w-3xl mx-auto m-0"
                        style={{
                          fontSize: "clamp(0.9rem, 1.2vw, 1.125rem)",
                          textAlign: "left",
                          color: "#212529",
                          fontWeight: 500
                        }}
                      >
                        Log in or create a free GPUwiz account to buy, sell and place bids/asks
                        on GPUs like stocks.
                      </p>
                    </div>
                    <form
                      className="form w-100 p-0 custom-logindata"
                      onSubmit={handleSubmit}
                    >
                      <div className="input-container w-100">
                        <label className="label fs-5 mb-2">Email:</label>
                        <input
                          ref={usernameInputRef}
                          type="text"
                          name="username"
                          className="input form-control"
                          placeholder="Email"
                          autoComplete="new-username"
                          value={username}
                          required
                          onChange={handleChange}
                        />
                      </div>
                      <div className="input-container w-100">
                        <label className="label fs-5 mb-2">Password: </label>
                        <div className="inner_part_icon">
                          <input
                            type={passwordStatus ? "text" : "password"}
                            name="password"
                            autoComplete="new-password"
                            className="input form-control mb-3"
                            placeholder="Password"
                            value={password}
                            required
                            onChange={handleChange}
                          />

                          {passwordStatus ? (
                            <span style={{cursor : "pointer"}} onClick={() => setPasswordStatus(!passwordStatus)}>
                              <EyeIconSvg />
                            </span>
                           
                          ) : (
                            <span style={{cursor : "pointer"}} onClick={() => setPasswordStatus(!passwordStatus)}>
                              <EyeIconHideSvg/>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="forgot_password">
                        <Button
                          className="custom-forgot float-right border-0 bg-none text-dark"
                          onClick={handleForgotPassword}
                        >
                          Forgot Password?
                        </Button>
                      </div>
                      <div className="w-100 d-flex flex-row gap-1 mb-2">
                        <button
                          type="submit"
                          className=" d-block  custom-login"
                          id={`${!customButtonStyle ? "login-btn" : "login-btn-custom" }`}
                          disabled={buttonLoader}

                        >
                          {buttonLoader ? "Please Wait..." : "Login"}
                        </button>
                        <button
                          type="button"
                          className=" d-block  custom-login"
                          id={`${!customButtonStyle ? "login-btn" : "login-btn-custom" }`}
                          // disabled={buttonLoader}
                          onClick={() => {
                            setSignup(true);
                            setForgot(false);
                          }}
                        >
                          Signup
                        </button>
                      </div>
                    </form>
                  </>
                )
              }
            </Modal.Body>
          </Modal>
        ) : (
          <>
            {
              signup ? (
                <Signup windowEvent={windowEvent} setSignup={setSignup} setForgot={setForgot} modal={modal} customButtonStyle={customButtonStyle} />
              ) : forgot ? (
                <ForgotPassword setSignup={setSignup} setForgot={setForgot} modal={modal} customButtonStyle={customButtonStyle} />
              ) : (
                <>
                  <div>
                    <p
                      className="max-w-3xl mx-auto m-0"
                      style={{
                        fontSize: "clamp(0.9rem, 1.2vw, 1.125rem)",
                        textAlign: "left",
                        color: "#212529",
                        fontWeight: 500
                      }}
                    >
                      Log in or create a free GPUwiz account to buy, sell and place bids/asks
                      on GPUs like stocks.
                    </p>
                  </div>
                  <form
                    className="form w-100 p-0 custom-logindata"
                    onSubmit={handleSubmit}
                  >
                    <div className="input-container w-100">
                      <label className="label fs-5 mb-2">Email:</label>
                      <input
                        ref={usernameInputRef}
                        type="text"
                        name="username"
                        className="input form-control"
                        placeholder="Email"
                        autoComplete="new-username"
                        value={username}
                        required
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container w-100">
                      <label className="label fs-5 mb-2">Password: </label>
                      <div className="inner_part_icon">
                        <input
                          type={passwordStatus ? "text" : "password"}
                          name="password"
                          autoComplete="new-password"
                          className="input form-control mb-3"
                          placeholder="Password"
                          value={password}
                                required
                                onChange={handleChange}
                              />

                              {passwordStatus ? (
                                <span style={{cursor : "pointer"}} onClick={() => setPasswordStatus(!passwordStatus)}>
                                  <EyeIconSvg />
                                </span>

                              ) : (
                                <span style={{cursor : "pointer"}} onClick={() => setPasswordStatus(!passwordStatus)}>
                                  <EyeIconHideSvg />
                                </span>
                              )}
                            </div>
                          </div>
                    <div className="forgot_password">
                      <Button
                        className="custom-forgot float-right border-0 bg-none text-dark"
                        onClick={handleForgotPassword}
                      >
                        Forgot Password?
                      </Button>
                    </div>
                    <div className="w-100 d-flex flex-row gap-1 mb-2">
                      <button
                        type="submit"
                        className="d-block custom-login"
                        id={`${!customButtonStyle ? "login-btn" : "login-btn-custom" }`}
                        disabled={buttonLoader}

                      >
                        {buttonLoader ? "Please Wait..." : "Login"}
                      </button>
                      <button
                        type="button"
                        className="d-block custom-login"
                        id={`${!customButtonStyle ? "login-btn" : "login-btn-custom" }`}
                        // disabled={buttonLoader}
                        onClick={() => {
                          setSignup(true);
                          setForgot(false);
                        }}
                      >
                        Signup
                      </button>
                    </div>
                  </form>
                </>
              )
            }
          </>
        )
      }


      {
        showQRModal && (
          <div>
            <div className="mb-4">
              <p className="qrspace">
                Two-Factor Authentication (2FA) is enabled on your account.
                To proceed, please enter the 6-digit code we’ve sent to your registered email.
              </p>
            </div>
            <InputOTP
              autoFocus
              value={otp.split("")}
              onChange={handleOTPChange}
              length={6}
              style={{ height: "50px" }}
            />

            <div className="mt-4 flex flex-col items-center text-center">
              <p className="text-sm text-gray-600 mt-2">
                Your OTP is valid for <span className="font-semibold">{timer}s</span>. <br />
                Didn’t receive it?{" "}
                <span
                  className="text-primary"
                  style={{ cursor: "pointer", textDecoration: "none" }} onClick={handleResend}
                >
                  Resend OTP
                </span>
              </p>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <Button style={{ marginTop: '30px' }} variant="secondary" onClick={() => setShowQRModal(false)}>
                Close
              </Button>

              <Button
                id={`${!customButtonStyle ? "login-btn" : "login-btn-custom" }`}
                variant="primary"
                onClick={handleOTPSubmit}
                disabled={!otp || otp.length !== 6}
              >
                Verify OTP
              </Button>
            </div>
          </div>
        )
      }
    </div>
  );
}

export default Login;
